<template>
  <paypal-checkout
    amount="10.00"
    currency="USD"
    :client="paypal">
  </paypal-checkout>
</template>

<script>
import PayPal from 'vue-paypal-checkout'
export default {
  data () {
    return {
      paypal: {
        sandbox: '<sandbox client id>',
        production: '<production client id>'
      }
    }
  },
  components: {
    PayPal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vogue.vue